export const headerTheme = {
  boxShadow: 'palette.black:0.06',
  container: 'palette.surface.2',
  timerIcon: 'palette.tertiary.80',

  downloads: {
    hover: {
      icon: 'palette.tertiary.95',
    },
    icon: 'palette.tertiary.80',
    iconDot: 'palette.primary.50',
  },

  bell: {
    counter: {
      bg: 'palette.error.70',
      text: 'palette.tertiary.99',
    },
  },
};
